import { useCallback } from 'react';
import { useMemo } from 'react';
import { useObservation } from 'apps/sigma2-ui/src/state/observation';
import { FocusAreaDefinition } from 'libs/end-to-end/src/types/databases/focus-areas/focus-area-definition';

export interface UseFocusAreaPayload {
  getFocusAreaByMetric: (params: {
    metric: string;
  }) => FocusAreaDefinition | undefined;
}

export const useFocusArea = (): UseFocusAreaPayload => {
  const { myObservation } = useObservation();

  const getFocusAreaByMetric = useCallback(
    ({ metric }: { metric: string }) => {
      return myObservation?.focusAreas.find((f) =>
        f.metrics.some((m) => m.columnHeaderValue === metric),
      );
    },
    [myObservation],
  );

  return useMemo(
    () => ({
      getFocusAreaByMetric,
    }),
    [getFocusAreaByMetric],
  );
};
